<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  highlighted?: boolean
}
const props = defineProps<Props>()

// computed
const rowClass = computed(() => {
  const result: string[] = []
  if (props.highlighted)
    result.push('odd:[&>td]:bg-neutral-light-5 even:[&>td]:bg-neutral-light-6')
  else
    result.push(
      'odd:[&>td]:bg-neutral-light-8 even:[&>td]:bg-neutral-light-10 odd:hover:[&>td]:bg-neutral-light-7 even:hover:[&>td]:bg-neutral-light-7',
    )
  return result.join(' ')
})
</script>

<template>
  <tr :class="rowClass">
    <slot />
  </tr>
</template>
